/* eslint-disable @nx/enforce-module-boundaries */
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AssetBasketComponent, AssetsPageComponent } from '@thehubz/client/assets-module';
import { canActivateRoleRoute } from '@thehubz/client/core';
import { UserProfileComponent } from '@thehubz/client/user-profile';
import { GlobalRole } from '@thehubz/shared/user-access';
import { LayoutComponent } from './components/layout.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'user/profile',
        component: UserProfileComponent,
        canActivate: [canActivateRoleRoute],
        data: { redirect: '/jackpot-assets' },
      },
      {
        path: 'assets',
        component: AssetsPageComponent,
        canActivate: [canActivateRoleRoute],
        data: { role: GlobalRole.library, redirect: '/jackpot-assets' },
      },
      {
        path: 'assets/detail/:id',
        canActivate: [canActivateRoleRoute],
        data: { redirect: '/jackpot-assets' },
        loadChildren: () => import('@thehubz/client/assets-module').then((m) => m.ClientAssetsDetailViewModule),
      },
      {
        path: 'assets-basket',
        component: AssetBasketComponent,
        canActivate: [canActivateRoleRoute],
        data: { role: GlobalRole.library, redirect: '/jackpot-assets' },
      },
      {
        path: 'collections',
        canActivate: [canActivateRoleRoute],
        data: { role: GlobalRole.library, redirect: '/jackpot-assets' },
        loadChildren: () => import('@thehubz/client/assets-module').then((m) => m.CollectionsModule),
      },
      {
        path: 'collections/collection-asset-list/:id',
        canActivate: [canActivateRoleRoute],
        data: { redirect: '/jackpot-assets' },
        loadChildren: () => import('@thehubz/client/assets-module').then((m) => m.CollectionAssetViewModule),
      },
      {
        path: 'admin',
        canActivate: [canActivateRoleRoute],
        data: { role: GlobalRole.admin, redirect: '/jackpot-assets' },
        loadChildren: () => import('@thehubz/client/admin').then((m) => m.ClientAdminModule),
      },
      {
        path: '**',
        redirectTo: '/jackpot-assets',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomRoutingModule {}
